<template>
	<div>
		<MainTempComp
			ref="mainTempRef"
			:searchOption="data.searchOption"
			:handleSearch="handleSearch"
			:showPage="false"
		>
			<template #header>
				<span style="padding-left: 10px"></span>
				<el-button type="primary" @click="data.showAddAndEdit = true"
					>添加</el-button
				>
			</template>
			<template #main>
				<tableComp :tableData="data.tableData"></tableComp>
			</template>
		</MainTempComp>
		<addAndEdit
			v-if="data.showAddAndEdit"
			v-model:toggle="data.showAddAndEdit"
		></addAndEdit>
	</div>
</template>

<script>
import { onMounted, provide, reactive, ref } from "vue";
import tableComp from "./table.vue";
import { apiCarWashFeeList } from "@/api/requestApis.js";
import addAndEdit from "./addAndEdit.vue";
export default {
	name: "systemSettings",
	components: {
		addAndEdit,
		tableComp,
	},
	setup() {
		const mainTempRef = ref(null);

		const data = reactive({
			showAddAndEdit: false,
			tableData: [],
			searchOption: [],
		});
		const handleSearch = async () => {
			const res = await apiCarWashFeeList({
				...mainTempRef.value.searchParams,
			});
			data.tableData = res || [];
		};

		const handleUpdateTable = () => {
			handleSearch();
		};
		provide("handleUpdateTable", handleUpdateTable);
		provide("handleSearch", handleSearch);
		onMounted(() => {
			handleSearch();
		});
		return {
			mainTempRef,
			data,
			handleSearch,
		};
	},
};
</script>

<style scoped>
</style>
